import { useEffect, useState } from "react";
function useLocation() {
    const [location, setLocation] = useState(window.location);
    useEffect(() => {
        let lastLocation = window.location.href;
        const intervalId = setInterval(() => {
            if (window.location.href !== lastLocation) {
                lastLocation = window.location.href;
                setLocation(Object.assign({}, window.location));
            }
        }, 100);
        return () => clearInterval(intervalId);
    }, [window.location]);
    return location;
}
export default useLocation;
